"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductPopupStore = void 0;
const pinia_1 = require("pinia");
const ProductPopupStatuses_1 = require("./ProductPopupStatuses");
const i18n_1 = require("../../common/i18n");
const ShopConfig_1 = require("../../common/utils/ShopConfig");
const axaptaPopupHost = ShopConfig_1.ShopConfig.getAxaptaPopupHost();
const dataUrl = axaptaPopupHost + '/axapta-product-popup/%productId%?jsonFormat=1&locale=%locale%';
exports.useProductPopupStore = (0, pinia_1.defineStore)('productPopup', {
    state: () => ({
        widgetState: ProductPopupStatuses_1.Statuses.suspended,
        product: null,
        productSku: null,
        productData: null
    }),
    getters: {
        modalIsOpen: (state) => state.widgetState !== ProductPopupStatuses_1.Statuses.suspended,
        modalIsLoading: (state) => state.widgetState === ProductPopupStatuses_1.Statuses.loading,
        isNotFound: (state) => state.widgetState === ProductPopupStatuses_1.Statuses.notFound,
        productInfo: (state) => state.product,
    },
    actions: {
        show(product, productData) {
            this.product = product;
            this.productSku = product.sku;
            this.widgetState = ProductPopupStatuses_1.Statuses.showing;
            this.productData = productData;
        },
        suspend() {
            this.widgetState = ProductPopupStatuses_1.Statuses.suspended;
        },
        load() {
            this.product = null;
            this.productSku = '';
            this.widgetState = ProductPopupStatuses_1.Statuses.loading;
        },
        notFound(product, productData, productId) {
            this.product = product;
            this.productSku = productId;
            this.widgetState = ProductPopupStatuses_1.Statuses.notFound;
            this.productData = productData;
        },
        async beginProcess(productData) {
            const productId = productData.id;
            if ('' === productId) {
                return Promise.reject('Product ID is empty');
            }
            const locale = i18n_1.i18n.locale.value;
            this.load();
            try {
                const response = await fetch(dataUrl.replace('%productId%', productId).replace('%locale%', locale));
                if (response.status === 200) {
                    const product = await response.json();
                    this.show(product, productData);
                    return response;
                }
                if (response.status === 404) {
                    const product = await response.json();
                    this.notFound(product, productData, productId);
                    return response;
                }
                throw response;
            }
            catch (error) {
                console.error('Error in beginProcess:', error);
                throw error;
            }
        },
        close() {
            this.suspend();
        }
    }
});
